






















import JMessageArticleList from "@/general/components/pages/parts/ThanksPointList/JMessageArticleList.vue";
import ButtonMore from "@/common/components/atoms/ButtonMore.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import { ListResponse, ThankPointSearchByUser } from "@/general/store/models";
import ThanksPointApi from "@/general/api/thanksPointApi";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";

@Component({
  components: {
    JMessageArticleList,
    ButtonMore
  }
})
export default class J03ResultScreenUser extends Vue {
  @Prop({ type: Object, required: true }) resultObject!: any;
  @Prop({ type: Array, default: [] }) exclude!: any;
  @Prop({ type: [String, Boolean], required: true }) heading!: string;
  @Prop({ type: [Boolean, Number], default: false })
  messagesSearchResultsCount!: boolean;
  @Prop({ type: String, required: true }) moreLink!: string;

  formattedResultArray: any = [];
  showState = 0;
  maxLength = 0;
  //itemCount = 0;

  get itemCount() {
    return this.resultObject.total_count;
  }

  get itemCountString() {
    const itemCount = this.itemCount;
    return itemCount <= 100 ? `（${itemCount}）` : "（100+）";
  }

  get moreButtonIsExists() {
    const exclude = this.exclude;
    const isExists = exclude.includes("moreButton");
    return !isExists;
  }

  get moreButtonIsShown() {
    const showState = this.showState;
    const maxLength = this.maxLength;
    const itemIsExists = showState < maxLength - 1;
    return itemIsExists;
  }

  get resultArray() {
    return this.resultObject.items;
  }

  async created() {
    this.setTheOriginalArrayDataInfo();
  }

  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }

  setTheOriginalArrayDataInfo() {
    const resultArray = this.resultArray;
    if (this.resultArray.length > this.pageSize) {
      this.formattedResultArray[0] = resultArray.slice(0, this.pageSize);
    } else {
      this.formattedResultArray[0] = resultArray;
    }

    this.maxLength =
      this.itemCount % this.pageSize >= 1
        ? Math.floor(this.itemCount / this.pageSize) + 1
        : this.itemCount / this.pageSize;
  }

  createArrayForMoreView() {
    const resultArray = this.resultArray;
    const duplicateResultArray = resultArray.slice();
    const formattedResultArray = this.createCurrentResultArray(
      duplicateResultArray,
      20,
      10
    );

    this.formattedResultArray = formattedResultArray;
    this.registerArrayLength(formattedResultArray);
  }

  registerArrayLength(formattedResultArray: any) {
    this.maxLength = formattedResultArray.length;
  }

  createCurrentResultArray(array: any, n: any, firstLength = 3) {
    const createFirstValue = [];
    createFirstValue[0] = array.splice(0, firstLength);

    const splitBaseArray = array.splice(0);
    const splitArray = this.splitArray(splitBaseArray, n);
    const newRenderArray = createFirstValue.concat(splitArray);
    return newRenderArray;
  }

  splitArray(splitBaseArray: any, n: any) {
    return Array.from(
      { length: Math.ceil(splitBaseArray.length / n) },
      (v, i) => splitBaseArray.slice(i * n, i * n + n)
    );
  }

  async moreView() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pageParam = urlParams.get("page");
    const search = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : "";

    this.showState += 1;
    const temp: any = [];

    // ページ指定、続きから取得などをここでやりたいが、期待値通りに動かなそうなので個別に処理
    const searchByUser: ListResponse<ThankPointSearchByUser> = await ThanksPointApi.searchThanksPointByUser(
      this.showState + 1,
      this.pageSize,
      search
    );
    if (searchByUser && searchByUser.results) {
      const end =
        searchByUser.results.length >
        this.showState * this.pageSize + this.pageSize
          ? this.showState * this.pageSize + this.pageSize
          : searchByUser.results.length;
      const searchByUserList = searchByUser.results.slice(
        this.showState * this.pageSize,
        end
      );
      searchByUserList.forEach((resObj) => {
        temp.push({
          id: resObj?.user?.using_employee_id,
          name: resObj?.user?.user_name,
          content: "",
          unread_count: resObj?.unread_count,
          url: `${SITE_MAP.THANKS_POINT_USER_SPECIFIC}?search=${search}&id=${resObj.user.id}`,
          icon: {
            original: "",
            large: "",
            medium: resObj?.user?.user_image,
            small: ""
          },
          point: {
            point_addition: false,
            state: "send"
          },
          unread: true,
          unreadCount: resObj?.thanks_giving_count
        });
      });
    }

    this.formattedResultArray.push(temp);
  }
}
